<template>
    <a :href="url" target="_blank" class="box compact">
        <div class="pl-0 pr-3">
            <div v-if="published" class="d-flex align-items-center">
                <span v-if="published" class="font-weight-normal">{{ published | formatDate }}</span>
            </div>
            <h6 class="my-2">{{ heading }}</h6>
            <p v-if="description" v-html="description"></p>
        </div>
    </a>
</template>

<script>
    import moment from 'moment';
    export default {
        filters: {
            formatDate: function (value) {
                if (value) {
                    return moment(value).format('DD.MM.YYYY')
                } else {
                    return "";
                }
            }
        },
        props: {
            heading: {
                type: String,
                required: true
            },
            url: {
                type: String,
                required: true
            },
            published: {
                type: String,
                required: false,
                default: null
            },
            description: {
                type: String,
                required: false,
                default: null
            }
        }
    }
</script>